import { CUSTOM_NOTES } from "static/constants";

const resolveExtractedDescription = (note, extractedData = {}) =>
  note?.associated_note ? extractedData?.[note.associated_note] || null : null;

/**
 * Merge incoming report note sections into the currently-rendered ones without
 * discarding user edits: new sections are added wholesale, and within an existing
 * section only content rows still flagged `isDefault` get their description replaced.
 */
export const mergeIncomingReportNotes = (
  currentNotes = [],
  incomingNotes = []
) => {
  return incomingNotes.map((incomingNote) => {
    const currentNote = currentNotes.find(
      (note) => note.note?.toLowerCase() === incomingNote.note?.toLowerCase()
    );

    if (!currentNote) return incomingNote;

    const content = incomingNote.content.map((incomingContent, index) => {
      const currentContent = currentNote.content?.[index];
      if (!currentContent || currentContent.isDefault) {
        return incomingContent;
      }
      return currentContent;
    });

    return { ...incomingNote, content };
  });
};

export const formatReportNotes = (
  reportNotes = [],
  isEditable = false,
  extractedData = {}
) => {
  const notes = reportNotes.filter(Boolean);
  const customNotes = notes.find(({ note }) => note === CUSTOM_NOTES);
  const filteredNotes = notes.filter(({ note }) => note !== CUSTOM_NOTES);

  const noteList = [
    ...filteredNotes,
    customNotes ?? { note: CUSTOM_NOTES, placeholders: [] },
  ];

  const reportNoteList = noteList?.reduce((acc, curr) => {
    const index = acc.findIndex(
      (item) => item.note?.toLowerCase() === curr.note?.toLowerCase()
    );

    if (index !== -1) {
      const placeholders = [
        ...acc[index].placeholders,
        ...(curr.placeholders || []),
      ];

      acc[index].placeholders = [...new Set(placeholders)]?.filter(Boolean);
      acc[index].content = [...acc[index].content, ...(curr.content || [])];
    } else {
      const placeholders = curr.placeholders || [];

      acc.push({
        ...curr,
        placeholders: [...new Set(placeholders)]?.filter(Boolean),
        content: curr.content || [],
      });
    }

    return acc;
  }, []);

  const reportNotesList = !isEditable
    ? reportNoteList
    : reportNoteList?.map((note) => ({
        ...note,
        content:
          note.content?.length === 0 && note.note !== CUSTOM_NOTES
            ? [
                {
                  description:
                    resolveExtractedDescription(note, extractedData) ||
                    note?.placeholders?.[0] ||
                    "",
                  alert: "None",
                  pageNumber: null,
                  isDefault: true,
                },
              ]
            : note.content,
      }));

  return reportNotesList;
};
